export function transformLangData(data, lang) {
  const output = {}

  for (const category in data) {
    output[category] = {}

    for (const key in data[category]) {
      const value = data[category][key]
      output[category][key] = value[lang] || Object.values(value)[0]
    }
  }

  return output
}
